import Vue from 'vue'

import * as types from './mutation-types'

export default {
  [types.SET_MONITOR_LIST] (state, monitors) {
    Vue.set(state, 'monitors', monitors)
  },
  [types.UPDATE_MONITOR_SETTINGS] (state, { index, settings }) {
    Vue.set(state.monitors[index], 'settings', Object.assign({}, state.monitors[index].settings, settings))
  },
  [types.UPDATE_MONITOR_NAME] (state, { index, name }) {
    Vue.set(state.monitors[index], 'name', name)
  }
}
